import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { Card } from '../components/ui';

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const token = params.get('token') ?? '';
  const [state, setState] = useState<'working' | 'ok' | 'error'>('working');
  const [error, setError] = useState('');
  // StrictMode double-invokes effects in dev; the token is single-use.
  const submitted = useRef(false);

  useEffect(() => {
    if (submitted.current) return;
    submitted.current = true;

    if (!token) {
      setState('error');
      setError('Missing token');
      return;
    }
    api.post('/api/auth/verify-email', { token })
      .then(async () => {
        setState('ok');
        await refresh();
      })
      .catch((err: unknown) => {
        setState('error');
        setError(err instanceof Error ? err.message : 'Verification failed');
      });
  }, [token, refresh]);

  return (
    <Card style={{ maxWidth: 400, margin: '2rem auto', textAlign: 'center' }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginTop: 0 }}>Email verification</h2>
      {state === 'working' && <p className="muted">Verifying…</p>}
      {state === 'ok' && (
        <>
          <div className="alert-success" style={{ margin: '1rem 0' }}>Your email address is verified.</div>
          <Link to="/dashboard" className="btn-primary">Go to dashboard</Link>
        </>
      )}
      {state === 'error' && (
        <>
          <div className="alert-error" style={{ margin: '1rem 0' }}>{error}</div>
          <Link to="/dashboard" className="btn-ghost">Back to dashboard</Link>
        </>
      )}
    </Card>
  );
}
